import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import { Box, Typography } from '@mui/material';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
`;

const breath = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
`;

// const pulse = keyframes`
//   0% {
//     transform: scale(1);
//     opacity: 1;
//   }
//   50% {
//     transform: scale(1.25);
//     opacity: 0.75;
//   }
//   100% {
//     transform: scale(1);
//     opacity: 1;
//   }
// `;

const wavePulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(8);
    opacity: 0;
  }
`;

export const Container = styled(Box)({
  width: '100%',
});

export const Arrow = styled('span')({
  display: 'inline-block',
  fontSize: '2rem',
  animation: `${bounce} 1s infinite ease-in-out`,
});

export const Wrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const IconBreath = styled('div')({
  animation: `${breath} 2.5s ease-in-out infinite`,
  color: '#2D11AD',
  fontSize: '28px',
});

export const IconCenter = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '37%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const IconPulse = styled('div')({
  animation: `${bounce} 1.2s ease-in-out infinite`,
  color: '#4F49E1',
  fontSize: '28px',
});

export const IconPulseWaveWrapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  zIndex: 2,
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: 'rgba(45, 17, 173, 0.3)',
    animation: `${wavePulse} 2s ease-out infinite`,
    zIndex: -1,
  },
});

export const ProgressWrapper = styled(Box)({
  width: '100%',
  height: '86px',
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '14px',
  paddingRight: '8px',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  minHeight: '60px',
});

export const UploadText = styled(Typography)({
  fontSize: 'clamp(18px, 5vw, 27px)',
  fontWeight: 500,
  lineHeight: 'clamp(20px, 5vw, 32px)',
  color: '#2D11AD',
});

export const KeepOpenText = styled(Typography)({
  textAlign: 'center',
  fontSize: 'clamp(14px, 3.9vw, 21px)',
  fontWeight: 400,
  lineHeight: 'clamp(16px, 3.9vw, 24px)',
  '@media (min-width: 430px)': {
    marginTop: '6px',
  },
});

export const UploadCompleteText = styled(Typography)<{ $color?: string }>(({ $color }) => ({
  fontSize: 'clamp(18px, 6vw, 24px)',
  fontWeight: 700,
  lineHeight: 'clamp(18px, 6vw, 24px)',
  color: $color,
  whiteSpace: 'nowrap',
}));

export const ThanksText = styled(Typography)({
  fontSize: 'clamp(13px, 3.9vw, 21px)',
  whiteSpace: 'nowrap',
  fontWeight: 400,
  lineHeight: '20px',
  color: '#475467',
  textAlign: 'left',
  marginTop: '6px',
  '@media (max-width: 360px)': {
    marginTop: '2px',
  },
});

export const StepsWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '20px',
  width: '100%',
});

export const StepText = styled(Typography)({
  fontSize: 'clamp(14px, 3.9vw, 21px)',
  fontWeight: 500,
  lineHeight: 'normal',
});

export const Step = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const UploadErrorWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const UploadFailText = styled(Typography)({
  fontSize: 'clamp(20px, 6vw, 26px)',
  fontWeight: 600,
  lineHeight: 'clamp(18px, 6vw, 24px)',
  color: '#ED2E38',
});

export const WeakConnectText = styled(Typography)({
  fontSize: 'clamp(14px, 3.9vw, 21px)',
  fontWeight: 400,
  lineHeight: '20px',
  color: '#475467',
  '@media (min-width: 430px)': {
    marginTop: '6px',
  },
});
